const E = {
  NoQuotes1: 'There are no active quotes for this client.',
  NoQuotes2: 'Please try another client.',
  DuplicateTest1: 'That test name is already taken.',
  DuplicateTest2: 'Please try another name.',
  NoTests: 'Please add at least one test.',
  SelectQuote: 'Select Quote',
  SearchSelectedQuote: 'Search Selected Quote',
  AvailableTests: 'Available Tests',
  RecommendedTests: 'Recommended Tests',
  SelectedTests: 'Selected Tests',
  ManuallyAdd: 'Manually Add a Test',
  SelectAllParameters: 'Select All Parameters',
  Parameter: 'Parameter',
  DetectionLimit: 'Detection Limit',
  ResubmissionOfJobs: 'Closing will keep this submission in editing mode. If you are ready to submit your changes, please click “Submit” on Step 5.',
  CustomizeParameterWarning: 'Your customized parameter selection will apply to any new samples you create. To modify the parameter selection on samples already created, simply click on the test name on step 3.',
  NoRecommendedTestsFound: 'Sorry, we are unable to provide any recommendations at this time.',
};

const F = {
  RecommendedTests: 'Analyses recommandées',
  NoRecommendedTestsFound: 'Désolé, nous ne pouvons fournir aucune recommandation pour le moment.',
  NoQuotes1: 'Aucun devis actif pour ce client.',
  NoQuotes2: 'Veuillez choisir un autre client.',
  DuplicateTest1: 'Ce nom d’analyse est déjà utilisé.',
  DuplicateTest2: 'Veuillez choisir un autre nom.',
  NoTests: 'Veuillez ajouter au moins une analyse.',
  SelectQuote: 'Sélectionner un devis.',
  SearchSelectedQuote: 'Chercher le devis sélectionné',
  AvailableTests: 'Analyses disponibles',
  SelectedTests: 'Analyses sélectionnées',
  ManuallyAdd: 'Ajouter une analyse manuellement',
  SelectAllParameters: 'Sélectionner toutes les analyses',
  Parameter: 'Paramètres',
  DetectionLimit: 'Limite de détection',
  ResubmissionOfJobs: 'Si vous fermez le devis, il restera en mode d’édition. Si vous êtes prêt à envoyer les modifications, cliquez sur Soumettre à l’étape 5.',
  CustomizeParameterWarning: "Votre sélection de paramètre personnalisé s'appliquera à tous les nouveaux échantillons que vous créez. Pour modifier la sélection de paramètres sur des échantillons déjà créés, cliquez simplement sur le nom du test à l'étape 3.",
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsTests.js